import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Layout from '~/components/Layout'
import VATItems from './VATItems'
import { FormProvider, useForm } from 'react-hook-form'
import MilkMoneyAccountingService from '~/api/services/milkMoneyAccounting'
import notify from '~/components/Notify'
import { El } from '~/components/Layout/style'
import { handleErrors } from '~/utils/helpers'

const VAT: React.FC = () => {
  const { t } = useTranslation()
  const [isBusy, setIsBusy] = useState(false)

  const methods = useForm({
    mode: 'onSubmit'
  })

  useEffect(() => {
    fetchData()
  }, [])

  async function fetchData() {
    setIsBusy(true)
    try {
      const response = await MilkMoneyAccountingService.getMilkVAT()
      methods.reset(response.data)
    } catch (error) {
      handleErrors(error)
    }
    setIsBusy(false)
  }

  function renderActions() {
    return <>
      <El.PageHeaderActionButton
      >{t('Update')}
      </El.PageHeaderActionButton>
    </>
  }

  async function onSubmit(data) {
    setIsBusy(true)
    try {
      data.saleTaxes?.forEach((saleTax, index) => {
        data.saleTaxes[index].percent = saleTax.percent.replace(',', '.')
      })
      await MilkMoneyAccountingService.updateMilkVAT(data)
      fetchData()
      notify(t('Successfully updated VAT'), 'success')
    } catch (error) {
      handleErrors(error)
    }
    setIsBusy(false)
  }

  return <Layout
    title={t('VAT')}
    actions={renderActions()}
    useSpinner
    childContainerSize={'300px'}
    fontSizeHeader={'18px'}
    isBusy={isBusy}
    onSubmit={methods.handleSubmit(onSubmit)}
  >
    <FormProvider {...methods}>
      <VATItems />
    </FormProvider>
  </Layout>
}
export default VAT